import React, { useState } from 'react';
import {
  Button, Card, CardBody, CardTitle, Col, Row,
} from 'reactstrap';
import toastr from 'toastr';
import { put } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

const money = (value) => (value == null ? '--' : `$${Number(value).toFixed(2)}`);

function ShippingExceptions() {
  const [showCleared, setShowCleared] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const setCleared = async (row, cleared) => {
    try {
      await put(`/api/log/shipping-exceptions/${row.id}/cleared`, { cleared });
      setRefresh((value) => value + 1);
    } catch (error) {
      toastr.error(error.message, 'Could not update shipping exception');
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">Shipping Exceptions</CardTitle>
                <Can i="see" this="Log">
                  <Button
                    color="secondary"
                    outline={!showCleared}
                    className="mb-3"
                    aria-pressed={showCleared}
                    onClick={() => setShowCleared((value) => !value)}
                  >
                    {showCleared ? 'Hide cleared' : 'Show cleared'}
                  </Button>
                  <BaseGrid
                    key={String(showCleared)}
                    url="/api/log/shipping-exceptions"
                    filters={showCleared ? 'show_cleared=1' : ''}
                    shouldUpdate={refresh}
                    config={{
                      columns: {
                        cleared: {
                          label: 'Cleared',
                          sort: true,
                          checkbox: {
                            checked: (row) => Boolean(Number(row.cleared)),
                            change: setCleared,
                          },
                        },
                        created_at: {
                          label: 'Date',
                          sort: true,
                          date: {
                            timezone: process.env.REACT_APP_LOCAL_TZ,
                            format: (d) => d.toLocaleString(),
                          },
                        },
                        order_id: {
                          label: 'Order ID',
                          sort: true,
                          link: { to: '/orders/%order_id%' },
                        },
                        carrier: { label: 'Carrier', sort: true },
                        reference: {
                          label: 'Reference',
                          sort: true,
                          link: { to: '/orders/%order_id%' },
                        },
                        label_code: { label: 'Label Code', sort: true },
                        shipping_paid: { label: 'Shipping Paid', sort: true, format: money },
                        calculated_shipping: { label: 'Calculated Shipping', sort: true, format: money },
                        actual_cost: { label: 'Actual Shipping Price', sort: true, format: money },
                        reason: { label: 'Reason' },
                      },
                      pagination: { sort: 'created_at', direction: 'desc', perPage: 50 },
                    }}
                  />
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ShippingExceptions;
